import type { IconSvgObject } from './types';

const LocationOffline02Icon: IconSvgObject = [
  ["path", { d: "M7 3.51555C8.4301 2.55827 10.1499 2 12 2C16.9706 2 21 6.02944 21 11C21 12.8656 20.3608 14.5181 19.423 15.9385M5.15559 5.15559C3.81158 6.72806 3 8.76925 3 11C3 18 12 22 12 22C12 22 15.2663 20.5483 17.8635 17.8635", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LocationOffline02Icon;
